import { useTranslation } from 'react-i18next';

import { useCheckout } from '../../../../../context';
import ProductCard from './components/ProductCard';
import { OutgoingMembershipProductDto } from 'api/dtos/memberships/products';

function Products() {
  const { products, cart, checkoutSession } = useCheckout();
  const { t } = useTranslation(['organizations']);

  const onSelect = async (product: OutgoingMembershipProductDto) => {
    const result = await cart.toggleProduct(product, true);

    if (result.asyncSetter) {
      const sessionUpdateResult = await checkoutSession.updateCheckout({
        updatedCart: result.products
      });

      if (sessionUpdateResult) {
        result.asyncSetter();
      }
    }
  };

  return (
    <div className="flex-1 md:w-2/3">
      <div className="px-4 not-first:border-t-2 md:border-t-0! border-neutral-200 pb-6 md:pb-11 gap-5 flex flex-col md:max-w-[650px] pt-6">
        <h3 className="text-neutral-900 text-lg font-bold flex items-center gap-1.5">
          {t('organizations:memberships.checkout.title')}
        </h3>
        <ul className="flex flex-col gap-5">
          {products.map((product) => (
            <li key={product.product.id}>
              <ProductCard
                product={product}
                onSelect={onSelect}
                isSelected={Boolean(cart.selectedProducts[product.product.id])}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Products;
